import {ModuleWithProviders, NgModule} from "@angular/core";

const sharedComponents = [];
const modules = [];

@NgModule({
    imports: [...modules],
    exports: [...modules, ...sharedComponents],
    declarations: [...sharedComponents]
})

export class SharedMiniModule {
    static forRoot(): ModuleWithProviders<SharedMiniModule> {
        return {
            ngModule: SharedMiniModule,
            providers: []
        };
    }
}
